import { Button } from "../../components/Button";
import { Card } from "../../components/Card";
import { PersonalDataConsent } from "../../components/PersonalDataConsent";
import { PROMO_EACH } from "./constants";

export function PromotionsBirthPromoCard({
  birthDate,
  setBirthDate,
  err,
  ok,
  submitting,
  onSubmit,
  onOpenPrivacyPolicy,
}) {
  return (
    <Card
      variant="light"
      className="promotionsPromoCard"
      title={`Укажите дату рождения — ${PROMO_EACH} бонусов`}
      subtitle="Чтобы мы знали, когда тебя поздравлять 💝."
    >
      <form className="promotionsPromoCard__form" onSubmit={onSubmit}>
        <PersonalDataConsent
          consentId="promo-pd-consent-birth"
          onOpenPrivacyPolicy={onOpenPrivacyPolicy}
        />
        <label className="field">
          Дата рождения
          <input
            type="date"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            required
          />
        </label>
        {err ? <p className="errorMessage">{err}</p> : null}
        {ok ? <p className="successMessage">{ok}</p> : null}
        <Button type="submit" variant="accent" disabled={submitting}>
          {submitting ? "Отправка…" : `Получить ${PROMO_EACH} бонусов`}
        </Button>
      </form>
    </Card>
  );
}
